import { render } from "./PageContent.vue?vue&type=template&id=06f73f88&scoped=true"
import script from "./PageContent.vue?vue&type=script&lang=ts"
export * from "./PageContent.vue?vue&type=script&lang=ts"

import "./PageContent.vue?vue&type=style&index=0&id=06f73f88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06f73f88"

export default script